import React, { useState } from "react";
import { View, Text } from "react-native";

import { Camera } from "utils";
import { getAddedFiles } from "state/modules/response/selectors";
import {
  TextArea,
  MediaTray,
  MediaPreview,
  IconButton,
  AudioButton,
  BoldText,
} from "components";
import { OTHER_TEXT_MAX_LENGTH } from "consts";

import { styles } from "./styles";

export const OpenEndedQuestion = props => {
  const { question, selectedOptions, setOptionOtherText, lang } = props;
  const { shouldShowAnswer } = props;
  const [option] = question.options;
  const selectedOption = selectedOptions[option.virtual_id] || {
    other_text: "",
  };

  const { allow_photo, allow_video, allow_audio } = option;
  const { addOptionFile, removeOptionFile, scrollToEnd } = props;

  const addFile = (file, type) => {
    addOptionFile(question, option, file, type);
    setTimeout(() => scrollToEnd(), 50);
  };
  const removeFile = id => removeOptionFile(question, option, id);

  const [audioEnabled, enableAudio] = useState(false);
  const { mediaFiles, audioFile } = getAddedFiles(selectedOption);

  const label =
    allow_photo && allow_video
      ? "Add Image / Video"
      : allow_video
      ? "Add Video"
      : "Add Image";

  const isCorrect = selectedOption.other_text === option.correct_answer;
  return (
    <View style={styles.container}>
      <TextArea
        maxLength={OTHER_TEXT_MAX_LENGTH}
        value={selectedOption.other_text || ""}
        placeholder={option[lang]}
        onChangeText={text => setOptionOtherText(question, option, text)}
        isCorrect={shouldShowAnswer ? isCorrect : null}
        editable={!shouldShowAnswer}
        child={
          <View>
            <MediaTray
              audio={allow_audio}
              video={allow_video}
              photo={allow_photo}
              enableAudio={() => enableAudio(!audioEnabled)}
              onCapture={addFile}
            />
          </View>
        }
      />
      {shouldShowAnswer && (
        <Text style={styles.correctAnswerMessage}>
          {isCorrect ? (
            "Correct!"
          ) : (
            <>
              <Text style={styles.correctAnswer}>
                <BoldText>{option.correct_answer}</BoldText>
              </Text>
              {" is the right answer"}
            </>
          )}
        </Text>
      )}
      <View style={styles.previews}>
        {mediaFiles.map(file => (
          <MediaPreview
            key={file.id}
            media={file}
            remove={() => removeFile(file.id)}
          />
        ))}
      </View>
      {!!mediaFiles.length && (
        <Camera video={allow_video} photo={allow_video} onCapture={addFile}>
          <IconButton text={label} icon="camera" />
        </Camera>
      )}
      {audioEnabled && (
        <AudioButton
          savedClip={audioFile.uri}
          onCapture={addFile}
          removeFile={() => removeFile(audioFile.id)}
        />
      )}
    </View>
  );
};
